import React, { useCallback } from 'react'
import {
  DEFAULT_AVATAR_IMAGE,
  toTalkPhotoUrl,
} from '../../helpers/static-constants'
import { Session } from '@talkjs/react'
import Talk from 'talkjs'
import { useAppSelector } from '../../store'
import { selectRestaurant } from '../../store/restaurant/setting'
import { useAuth0 } from '@auth0/auth0-react'
import Layout from './Layout'
import { selectChatToken } from '../../store/restaurant/messages'

const RestaurantLayout: React.FC = () => {
  const { isAuthenticated } = useAuth0()

  const restaurant = useAppSelector(selectRestaurant)
  const chatToken = useAppSelector(selectChatToken)

  const address = restaurant
    ? `${restaurant?.address1 ?? ''} ${restaurant?.city ?? ''}, ${
        restaurant?.state ?? ''
      }`
    : ''

  const syncUser = useCallback(
    () => {
      const photoUrl = toTalkPhotoUrl(
        restaurant?.imageUrl,
        DEFAULT_AVATAR_IMAGE,
      )
      return new Talk.User({
        id: restaurant?.restaurantId ?? '',
        name: restaurant?.name ?? '',
        email: restaurant?.contactEmail !== '' ? (restaurant?.contactEmail ?? null) : null,
        ...(photoUrl ? { photoUrl } : {}),
        welcomeMessage: 'Hey, how can I help?',
        role: 'restaurant-admin-messages',
        custom: {
          email: restaurant?.contactEmail !== '' ? (restaurant?.contactEmail ?? null) : null,
          address: address.trim(),
        },
      })
    },
    [restaurant],
  )

  // TODO: add chat token fetching
  // const fetchToken = async (): Promise<string> => {
  //   try {
  //     const res = await dispatch(fetchChatToken())
  //     if (fetchChatToken.fulfilled.match(res)) {
  //       return res.payload as string
  //     }
  //     return ''
  //   } catch (error) {
  //     return ''
  //   }
  // }
  return (
    <>
      {isAuthenticated &&
      restaurant &&
      chatToken &&
      restaurant?.restaurantId &&
      restaurant?.name ? (
        <Session
          appId={process.env.REACT_APP_TALK_JS ?? ''}
          syncUser={syncUser}
          token={chatToken}
          // tokenFetcher={fetchToken}
        >
          <Layout />
        </Session>
      ) : (
        <Layout />
      )}
    </>
  )
}

export default RestaurantLayout
